import { Subscription } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { Component, OnInit, Input } from '@angular/core';
import { DetalheBaseController } from '../../helpers';
import { AcordoService, PagamentoService, DevedorService, EmailService, BoletoService } from '../../services';
import * as _ from 'underscore';

@Component({
  selector: 'app-contrato-agregado',
  templateUrl: './contrato.agregado.component.html'  
})

export class ContratoAgregadoComponent extends DetalheBaseController implements OnInit {
    _dividasRecebidas: any = [];    
    @Input() 
    set dividasRecebidas(value) {
        this._dividasRecebidas = value;
        this.trataDividas();
    }

    dividas: any = [];    
    devedor: any = {};       
    subDividas: Subscription;  
    subPagamento: Subscription;
    showForm: boolean = false;    
    showBandeira: number = 0;
    maxCharCartao: number = 16;
    minCharCartao: number = 0;
    maxCS: number = 0;
    rotacionarCartao: boolean = false;
    meioPagamento: number = 1;
    lastTotal: number = 0;      

    _cartaoNumero: string = "XXXXXXXXXXXXXXXX";
    _cartaoNome: string = "XXXXXX XXXXXX";
    _cartaoMes: string = "XX";
    _cartaoAno: string = "XX";
    _cartaoCVV: string = "XXX";
    imagePath: string = "";
    showCartao: boolean = false;
    showCampoTelefone = false;
    imageCard: string = "";
    email: string;
    telefone: string;

                
    constructor(private router: Router, route: ActivatedRoute, private _acordoService: AcordoService, private _pagamentoService: PagamentoService,
        private _devedorService: DevedorService, private _emailService: EmailService, private _boletoService: BoletoService) {            
        super(route, _acordoService);        
    }  
    
    ngOnInit() {
        this.subGet = this._devedorService.getDevedorLogado().subscribe(result => {
            this.devedor = result;            
            if (this.devedor.emailsAtivos.length > 0)
                this.email = this.devedor.emailsAtivos[0].mail

            if (this.devedor.telefonesAtivos.length == 1) {
                this.showCampoTelefone = true;
                this.telefone = this.devedor.telefonesAtivos[0].ddd + this.devedor.telefonesAtivos[0].numero
            }
        });
    }

    trataDividas() {
        if (this._dividasRecebidas == undefined || this._dividasRecebidas.length <= 0) 
            return;        
        
        this.dividas = this.initObjDivida();
        var group = _.chain(this._dividasRecebidas)
          .groupBy(e => e.contratoId)
          .map(e => (e[0].count = e.length, e[0])).value().filter(item => item.acordoDivida == null); 
        
        if (group.reduce((acc, cur) => acc + cur.valorTotal, 0) == this.lastTotal)
          return;

        this.lastTotal = group.reduce((acc, cur) => acc + cur.valorTotal, 0);
        this._acordoService.getRegrasParcelamento(this.lastTotal).subscribe(result => {                                                   
            this.getDividas(group, result);
        });                 
    }
    
    getDividas(group, regrasParcelamento) {       
        this._loading.carregar();                        
        group.forEach(element => {                          
            this.dividas[0].contratoId += element.contratoId + ',';                
            this.dividas[0].numeroContrato += element.numeroContrato + ', ';             
            this.dividas[0].parcelaId += element.parcelaId + ','; 
            this.dividas[0].primeiroVencimento = element.primeiroVencimento;
            this.dividas[0].valorTotalComDesconto += element.valorTotalComDesconto;
            this.dividas[0].valorTotal += element.valorTotal;
            this.dividas[0].valorDoDesconto += element.valorDoDesconto;
            if (element.numeroMaximoParcela > this.dividas[0].numeroMaximoParcela) {
                this.dividas[0].numeroMaximoParcela = element.numeroMaximoParcela;                
                this.dividas[0].percentualMaximoDesconto = element.percentualMaximoDesconto;
            }
        });                

        this.dividas[0].numeroDivida = 1;
        this.dividas[0].numeroContrato = this.dividas[0].numeroContrato.substring(0, this.dividas[0].numeroContrato.length - 2)
        this.dividas[0].contratoId = this.dividas[0].contratoId.substring(0, this.dividas[0].contratoId.length - 1)
        this.dividas[0].parcelaId = this.dividas[0].parcelaId.substring(0, this.dividas[0].parcelaId.length - 1)          
        this.dividas[0].parcelas = this.ObterParcelas(this.dividas[0], regrasParcelamento);
        
        this.showForm = true;                                    
        this._loading.fecharTodos();                            
    }

    obterDadosAcordoRequest(contratoid: number, parcela: number, desconto: number, valor: number) {
        let dados = {
            contratoList: contratoid,
            numeroParcelaSelecionada: parcela,
            PorcentagemDesconto: desconto,
            ValorTotal: valor
        };
        return dados;
    }

    salvar(form) {           
        this._dialog.confirm('Fazer Acordo e Pagar', 'Confirmar o acordo e pagamento do(s) contrato(s)?', () => {                                        
            this._loading.carregar();

            if(!this.verificarTelefoneCelular()) {
                this._loading.fechar();
                return;
            }
            
            var desconto = this.dividas[0].parcelas.filter(x => x.index == this.dividas[0].quantidadeParcelasSelecionada);
            this._acordoService.postAcordoLote(this.obterDadosAcordoRequest(this.dividas[0].contratoId, this.dividas[0].quantidadeParcelasSelecionada, 
                desconto[0].percentualDesconto, this.dividas[0].valorTotal)).subscribe(result => {  

                if (this.meioPagamento == 1)
                    this.pagarViaCartaoCredito(form, result);                                                             
                else   
                    this._acordoService.get(this.service._api, result[0].id).subscribe(result => {
                        this.downloadBoleto(result.linkBoleto);       
                        this.enviarBoletoEmail(this.devedor.id, result.boletoId, this.email);
                        this.enviarBoletoSms(this.devedor.id, result.boletoId, this.telefone)
                        this.router.navigate(['/app/home']);                         
                    });                    
            });            
        });
    }

    pagarViaCartaoCredito(form, result) {          
        form.parcelaId = "";
        result.forEach(element => {
            element.acordoParcelas.forEach(element => {
                form.parcelaId += element.id + ",";
            });
        });
        
        form.operadora = 1;                 
        var valor = this.dividas[0].parcelas.filter(x => x.index == this.dividas[0].quantidadeParcelasSelecionada);        
        form.valor = valor[0].valorComDesconto;
        form.parcelaId = form.parcelaId.substring(0, form.parcelaId.length - 1)
        form.parcelas = this.dividas[0].quantidadeParcelasSelecionada;
        form.bandeira = this.showBandeira;
        form.dataExpiracao = form.dataValidade.substring(0, 2) + '/20' + form.dataValidade.substring(2, 6);
        this.subPagamento = this._pagamentoService.post("/api/boletos/" + "Pagar", form).subscribe(result => {
            if (result.codigoTransacao != null && result.codigoTransacao != "") {                    
                localStorage.setItem('msgSucesso', this.translate.instant("controllerBase.pagamentoComSucesso") + '!');                
                this.router.navigate(['/app/confirmWizard']);
            } else {
                this._notificationsService.Erro("Erro no Pagamento", "Código: " + result.erros[0].code + " - " + result.erros[0].message);
            }
            this._loading.fecharTodos();                    
        });
    }

    downloadBoleto(url) {         
        window.open(url, "_blank");
        this.router.navigate(['/app/confirmWizard']);
    }

    ObterParcelas(divida, regraParcelamento) {        
        let parcelas = [];
        let parcelaSelecionada =  1;
        
        divida.quantidadeParcelasSelecionada = parcelaSelecionada;
        for (let index = 1; index <= regraParcelamento.quantidadeMaximaParcelas; index++) {            
            var desconto =  regraParcelamento.parcelamentoDetalhe.filter(x => x.parcela == index);
            parcelas.push({ index: index, valorComDesconto: (divida.valorTotal * (1 - (desconto[0].desconto / 100))), 
                percentualDesconto: desconto[0].desconto, checked: index == parcelaSelecionada });
        }

        return parcelas;
    }

    FlipCard(value) {         
        if (value == "front")
            this.rotacionarCartao = false;
        else
            this.rotacionarCartao = true;
    }

    validDate(dValue, form) 
    {
        var result = false;
        var originalValue = dValue;
        dValue = dValue.substr(0,2) + "/" + dValue.substr(2,2);
        dValue = dValue.split('/');
        var pattern = /^\d{2}$/;
      
        if (dValue[0] < 1 || dValue[0] > 12)
            result = true;
      
        if (!pattern.test(dValue[0]) || !pattern.test(dValue[1]))
            result = true;
      
        if (dValue[2])
            result = true;
      
        if (result) 
            form.controls["dataValidade"].setErrors({'incorrect': true});
        
        this._cartaoMes = originalValue == "" ? "XX" : originalValue.substring(0,2);
        if (originalValue.length > 2)
            this._cartaoAno = originalValue == "" ? "XX" : originalValue.substring(2,4);
        else
            this._cartaoAno = "XX";
      }

    QualOperadora(cardNumber, form)
    {
        var visaRegex = /^(4)/;
        var masterRegex = /^(51|52|53|54|55)/;
        var amexRegex = /^(34|37)/;
        var eloRegex = /^(636368|636369|438935|504175|451416|636297|5067|4576|4011|506699)/;
        var auraRegex = /^(50)/;  
        var jcbRegex = /^(35[2-9][8-9]|35[0-8][0-9])/;
        var dinersRegex = /^(300|301|302|303|304|305|36)/;
        var discoverRegex = /^(6011|622|644|645|646|647|648|649|65)/;
        var hipercardRegex = /^(38|60)/;        
        
        if (visaRegex.test(cardNumber)) { // Visa
            this.showBandeira = 1; this.maxCharCartao = 16; 
            this.minCharCartao = 13; this.maxCS = 3;
            this.imagePath = "../assets/images/ccvisa_61x38.png";
            this.showCartao = true;
            this.imageCard = "../assets/images/ccvisa.png";
        } else if (masterRegex.test(cardNumber)) { // MasterCard
            this.showBandeira = 2; this.maxCharCartao = 19; 
            this.minCharCartao = 16; this.maxCS = 3;            
            this.imagePath = "../assets/images/ccmaster_61x38.png";
            this.showCartao = true;
            this.imageCard = "../assets/images/ccmaster.png";
        } else if (amexRegex.test(cardNumber)) { // Amex
            this.showBandeira = 3; this.maxCharCartao = 15; 
            this.minCharCartao = 15; this.maxCS = 4;
            this.imagePath = "../assets/images/ccamex_61x38.png";
            this.showCartao = true;
            this.imageCard = "../assets/images/ccamex.png";
        } else if (eloRegex.test(cardNumber)) { // Elo
            this.showBandeira = 4; this.maxCharCartao = 16; 
            this.minCharCartao = 16; this.maxCS = 3;
            this.imagePath = "../assets/images/ccelo_61x38.png";
            this.showCartao = false; this.imageCard = "";
        } else if (auraRegex.test(cardNumber)) { // Aura
            this.showBandeira = 5; this.maxCharCartao = 16; 
            this.minCharCartao = 16; this.maxCS = 3;
            this.imagePath = "../assets/images/ccaura_61x38.png";
            this.showCartao = false; this.imageCard = "";
        } else if (jcbRegex.test(cardNumber)) { // JCB
            this.showBandeira = 6; this.maxCharCartao = 16; 
            this.minCharCartao = 16; this.maxCS = 3;
            this.imagePath = "../assets/images/ccjcb_61x38.png";
            this.showCartao = false; this.imageCard = "";
        } else if (dinersRegex.test(cardNumber)) { // Diners
            this.showBandeira = 7; this.maxCharCartao = 14; 
            this.minCharCartao = 14; this.maxCS = 3;
            this.imagePath = "../assets/images/ccdiners_61x38.png";
            this.showCartao = false; this.imageCard = "";
        } else if (discoverRegex.test(cardNumber)) { // Discover
            this.showBandeira = 8; this.maxCharCartao = 16; 
            this.minCharCartao = 16; this.maxCS = 4;
            this.imagePath = "../assets/images/ccdiscover_61x38.png";
            this.showCartao = false; this.imageCard = "";
        } else if (hipercardRegex.test(cardNumber)) { // Hipercard
            this.showBandeira = 9; this.maxCharCartao = 19; 
            this.minCharCartao = 13; this.maxCS = 4;
            this.imagePath = "../assets/images/cchiper_61x38.png";
            this.showCartao = false; this.imageCard = "";
        } else {
            this.showBandeira = 0; this.maxCharCartao = 16; 
            this.minCharCartao = 13; this.maxCS = 3;
            form.controls["numero"].setErrors({'incorrect': true});
            this.imagePath = ""; this.showCartao = false; this.imageCard = "";
        }

        this._cartaoNumero = (cardNumber == "" || cardNumber == undefined) ? "XXXXXXXXXXXXXXXX" : cardNumber;
    }

    changeNome() {        
        this._cartaoNome = (this.model.nome == "" || this.model.nome == undefined) ? "XXXXXX XXXXXX" : this.model.nome;
    }

    changeCVV() {
        this._cartaoCVV = (this.model.codigoSeguranca == "" || this.model.codigoSeguranca == undefined) ? "XXX" : this.model.codigoSeguranca;
    }

    initObjDivida() {
        return [{
            contratoId: "",        
            numeroContrato: "",
            numeroMaximoParcela: 0,
            parcelaId: "",
            quantidadeParcelasSelecionada: 0,
            percentualDesconto: 0,
            percentualMaximoDesconto: 0,
            primeiroVencimento: null,
            valorTotalComDesconto: 0,
            valorTotal: 0,
            valorDoDesconto: 0,
            numeroDivida: 0,
            meioPagamento: 1,        
            parcelas: [{
                index: 0, 
                checked: false
            }]
        }];          
    }


    obterDadosEnvioBoletoEmail(devedorId: number, boletoid: number, email: string) {
        let dados = {
            devedorId: devedorId,
            boletoId: boletoid,
            email: email            
        };
        return dados;
    }

    obterDadosEnvioBoletoSms(devedorId: number, boletoid: number, telefone: string) {
        let dados = {
            devedorId: devedorId,
            boletoId: boletoid,
            dddTelefone: telefone.substr(0, 2),
            numeroTelefone: telefone.substr(2)            
        };
        return dados;
    }


    verificarTelefoneCelular() : boolean {              
        if(this.meioPagamento == 2) {
            if(this.model.telefone != undefined && this.model.telefone != 0) 
                this.telefone = this.model.telefone;

            if( this.telefone != undefined && this.telefone.length <=  10) {  
                this._notificationsService.Erro("Número Inválido", "Informe um número de celular correto!");            
                return false;
            } 
        }
        return true;
    }


    enviarBoletoEmail(devedorId: number, boletoid: number, email: string) {
        if(email != undefined)                       
            this._emailService.postBoletoEmail(this.obterDadosEnvioBoletoEmail(devedorId, boletoid,email)).subscribe(result => {});   
    }

    enviarBoletoSms(devedorId: number, boletoid: number, telefone: string) {
        if(telefone != undefined)  
            this._boletoService.postBoletoPorSms(this.obterDadosEnvioBoletoSms(devedorId, boletoid,telefone)).subscribe(result => {});   
    }   

    ngOnDestroy() {      
        if (this.subDividas) this.subDividas.unsubscribe();
        if (this.subPagamento) this.subPagamento.unsubscribe();        
        super.ngOnDestroy();
    }
}



// WEBPACK FOOTER //
// C:/Users/anderson.oshiro/Projetos/Azure/Ipcorp.PortalCobranca/Web/Ipcorp.PortalCobranca.Web/src/app/components/contrato/contrato.agregado.component.ts